export default __webpack_public_path__ + "static/B0249-400d9b9717f1b39039fec36acaf32bfd.png";